<template>
	<div>
		<div class="gray f-s-12 m-l-5">验证码已发送到</div>
		<div class='flex p-t-6'>
			<div class="phone-img-div">
				<img src="../../assets/phone.png" />
			</div>
			<div class="f-s-20 w-500 somber">{{xgUserInfo.mobile|mobile}}</div>
		</div>
		<div class='flex p-t-10 m-l-5'>
			<div class="code-input">
				<van-field type="number" :maxlength="step==1?6:4" :border="false" v-model="code"
					:placeholder="step==1?'请输入6位移动验证码':'请输入4位畅由验证码'" />
			</div>
			<div class="code-btn"
				:class="{'big-code-text':codeMsg!='获取验证码','code-step-1':step == 1,'code-step-2':step == 2}">
				<van-button type="primary" @click="getCode()" :disabled="codeMsg!='获取验证码'">{{codeMsg}}</van-button>
			</div>
		</div>

		<div class="transition-btn p-t-10 m-l-5" :class="{'code-step-1':step == 1,'code-step-2':step == 2}">
			<van-button type="primary" v-if="step == 1" :disabled="code==''" @click="willExchange">下一步</van-button>
			<van-button type="primary" v-if="step == 2" :disabled="code==''" @click="willPay">确认</van-button>
		</div>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant';
	import {
		sendCmccSms,
		sendCySms,
		doCmccExchange,
		doPay
	} from '@/request/api';
	import {
		mapState,
		mapGetters,
		mapMutations,
		mapActions
	} from "vuex"
	export default {
		name: 'Verify',
		computed: mapGetters(['xgUserInfo']),
		data() {
			return {
				orderDetailUrl: 'https://cyy.ydong.com.cn/1/succ?openid=',
				codeMsg: '获取验证码',
				code: '',
				codeTime: 60,
				codeTimer: '',
				timeout: '',
			}
		},
		props: {
			smsStatus: {
				type: Number,
				default: 0
			},
			step: {
				type: Number,
				default: 0
			},
			order: {
				type: Object,
				default: {}
			}
		},
		watch: {
			step: {
				immediate: true,
				handler(val) {
					if (val > 0) {
						this.stopCodeTimer()
						this.codeMsg = this.codeTime + "S";
						this.codeTimer = setInterval(this.reduceTime, 1000);
					}
				}

			}
		},
		methods: {
			...mapMutations(['xsSubCyScore', 'xsAddCyScore', 'xsSubCmccScore']),
			willPay() {
				if (this.timeout) {
					clearTimeout(this.timeout)
				}
				this.timeout = setTimeout(() => {
					this.doPay();
				}, 500);
			},
			willExchange() {
				if (this.timeout) {
					clearTimeout(this.timeout)
				}
				this.timeout = setTimeout(() => {
					this.exchange();
				}, 500);
			},
			exchange() {
				doCmccExchange({
					scoreOrderId: this.order.scoreOrderId,
					optCode: this.code
				}).then(res => {
					if (res.exchangeStatus == 1) {
						this.code = ''
						//新增畅游积分
						this.xsAddCyScore(this.order.toCyScore)
						//扣减移动积分
						this.xsSubCyScore(this.order.cmssScore)
						//设置定时器
						if (res.paySendStatus == 1) {
							this.stopCodeTimer()
							this.codeMsg = this.codeTime + "S";
							this.codeTimer = setInterval(this.reduceTime, 1000);
						}
						//下一步
						this.$emit('nextStep')
						//清楚定时器
						this.stopCodeTimer()
					} else {
						this.$emit('payError')
					}
				})
			},
			doPay() {
				doPay({
					scoreOrderId: this.order.scoreOrderId,
					optCode: this.code
				}).then(res => {
					//转换
					this.code = ''
					//清楚定时器
					this.stopCodeTimer()
					if (res.payStatus == 1) {
						//扣减畅游积分
						this.xsSubCyScore(this.order.cyScore)
						//跳转页面
						window.location = this.orderDetailUrl + this.xgUserInfo.openId + '&providerCode=' + this
							.xgUserInfo.providerCode
					} else {
						this.$emit('payError')
					}
				})
			},
			//获取验证码
			getCode() {
				//开启定时器
				this.codeMsg = this.codeTime + "S";
				this.codeTimer = setInterval(this.reduceTime, 1000);
				this.sendCode();

			},
			sendCode() {
				if (this.step == 1) {
					sendCmccSms({
						scoreOrderId: this.order.scoreOrderId
					}).then(res => {
						Toast.success('验证码已发送')
					})
				} else {
					sendCySms({
						scoreOrderId: this.order.scoreOrderId
					}).then(res => {
						Toast.success('验证码已发送')
					})
				}

			},
			//定时器-验证码
			reduceTime() {
				this.codeTime--;
				if (this.codeTime == 0) {
					this.stopCodeTimer();
				} else {
					this.codeMsg = this.codeTime + "S";
				}

			},

			stopCodeTimer() {
				clearInterval(this.codeTimer);
				this.codeTime = 60;
				this.codeMsg = "获取验证码";
			}

		},
	}
</script>

<style scoped>
	.code-input {
		padding: 2px;
		border: 1px solid #828382;
		border-radius: 8px;
		flex: 1;
	}

	.code-btn {
		width: max-content;
		padding-left: 5px;
	}

	.code-input /deep/ .van-field {
		padding: 8px 15px;
	}

	.code-btn /deep/ .van-button--normal {
		font-size: 12px;
		background-color: #ec616c;
		border-color: #ec616c;
		border-radius: 8px;
	}

	.big-code-text /deep/ .van-button--normal {
		font-size: 15px;
	}

	.code-step-1 /deep/ .van-button--normal {
		background-color: #ec616c;
		border-color: #ec616c;
	}

	.code-step-2 /deep/ .van-button--normal {
		background-color: #538bf3;
		border-color: #538bf3;
	}

	.transition-btn /deep/ .van-button--normal {
		width: 100%;
		border-radius: 5px;
	}

	.phone-img-div {
		width: 20px;
	}

	.phone-img-div>img {
		width: 100%;
	}
</style>
